<div *ngIf="calculatedTime">{{ 'OFFER_EXPIRATION.LABEL' | translate }} {{ calculatedTime ? (calculatedTime > 0 ? message : 'expired') : '15:00' }}</div>
